<template>
  <div class="container-toast-item">
    <div class="toast-item">
      <span class="text">{{ toastMessage }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastItem',
  props: {
    message: {
      type: String,
    },
    removeToastItemFunc: Function,
  },
  mounted() {
    setTimeout(() => {
      const funcCall = this.removeToastItemFunc;
      funcCall();
    }, 2000);
  },
  data() {
    return {
      toastMessage: this.message,
    };
  },
};

</script>

<style lang="scss" scoped>
.container-toast-item {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  align-content: flex-end;

  width: 100%;

  margin-top: 8px;
  border-radius: 8px;

  .toast-item {
    padding: 18px 24px;
    background-color: rgba(0,0,0,0.6);

    margin-top: 8px;
    border-radius: 8px;

    .text {
      color: #ffffff;

      width: auto;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/toast/components/ToastItem.vue